// @flow
import React from "react";

import { FormInput } from "../form-input/index";

import { Validation } from "../../model/validation";

import { Button } from "../button";

type Props = {
    email: string,
    emailValidation: Validation,
    password: string,
    passwordValidation: Validation,
    serverValidateFail: boolean,
    serverValidateMsg: ?string,
    disabledLogin: boolean,
    status: "" | "loading",
    loginButtonText: string,
    onEmailChanged: (e: Event, value: string) => any,
    onPasswordChanged: (e: Event, value: string) => any,
    onSubmit: (e: Event) => any
};

export function Login(props: Props) {
    return (
        <form name="loginForm" id="loginForm" onSubmit={props.onSubmit}>
            <FormInput
                inputId="email"
                type="email"
                value={props.email}
                label="Email Address"
                placeholder="Email Address"
                valid={props.emailValidation}
                onChange={props.onEmailChanged}
                tealeafPIIValue="m"
            />
            <FormInput
                inputId="password"
                type="password"
                value={props.password}
                label="Password"
                placeholder="Password"
                valid={props.passwordValidation}
                onChange={props.onPasswordChanged}
                tealeafPIIValue="h"
            />
            {props.status !== "loading" &&
                props.serverValidateFail && (
                    <div className="form-row">
                        <span
                            className="form-error-msg form-error-msg--server"
                            dangerouslySetInnerHTML={{
                                __html: props.serverValidateMsg
                            }}
                        />
                    </div>
                )}
            <div className="form-row form-row-cta">
                <Button
                    id="login"
                    type="submit"
                    disabled={props.disabledLogin}
                    status={props.status}
                >
                    {props.loginButtonText}
                </Button>
            </div>
        </form>
    );
}
